module.exports = __webpack_public_path__ + "img/basket_result_ico.f0083b3f.svg";